<template>
  <div class="callout" :class="[`callout--${type}`]">
    <svg-icon
      class="callout__icon"
      name="callout_error"
      @click="$emit('close')"
    />
    <div class="callout__text">
      <slot />
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/shared/ui/SvgIcon/SvgIcon.vue'

export default {
  name: 'Callout',
  components: {
    SvgIcon,
  },
  props: {
    type: {
      type: String,
      validator(value) {
        return ['error'].includes(value)
      },
    },
  },
}
</script>

<style scoped lang="scss">
.callout {
  display: flex;
  gap: 15px;
  width: 100%;
  text-align: center;
  border-radius: 8px;
  background: var(--bg-7);
  padding: 14px;
  margin: 1.5rem 0;

  &__text {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.5rem;
    color: var(--text-1);
  }

  &__icon {
    width: 26px;
    height: 26px;
    cursor: pointer;
  }
}
</style>
